<style lang="scss" scoped>
  .list {
    display: flex;
    align-items: center;
    .img {
      width: 148px;
      height: 148px;
      margin-right: 10px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      &:hover .shadow {
        opacity: 1;
      }
    }
    .shadow {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      cursor: pointer;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
</style>

<template>
  <div class="list">
    <div class="img" v-if="type != 'list' && url">
      <img :src="getUrl1(url)" />
      <div class="shadow" @click="edit">
        <i class="el-icon-edit"></i>
      </div>
    </div>
    <div v-else v-for="(item, index) in imageUrl" :key="index" class="img">
      <img :src="getUrl1(item)" />
      <div class="shadow" @click="del(index)">
        <i class="el-icon-delete"></i>
      </div>
    </div>
    <el-upload
      v-show="imageUrl.length < limit && !url"
      action
      list-type="picture-card"
      :http-request="fnUploadRequest"
      :show-file-list="false"
      :before-upload="beforeUpload"
      ref="uploadComponent"
    >
      <i class="el-icon-plus" />
    </el-upload>
  </div>
</template>

<script>

export default {
	components: {},
	props: {
		type: {
			type: String,
			default: 'list'
		},
		url: {
			type: String,
			default: ''
		},
		imageUrl: {
			type: Array,
			default: () => []
		},
		limit: {
			type: Number,
			default: 5
		},
		state: {
			type: Number,
			default: 1
		},
		uploadKey: {
			type: String,
			default: 'dishes'
		},
		merchantId: {
			type: String,
			default: ''
		},
		maxSize: {
			type: Number,
			default: 500
		},
		maxSizeUnit: {
			type: String,
			default: '500KB'
		}
	},
	computed: {
		baseUrl () {
			return this.$store.getters.url
		}
	},
	data () {
		return {}
	},
	mounted () {},
	methods: {
		getUrl1 (item) {
			console.log(item, /(http|https):\/\/([\w.]+\/?)\S*/.test(item))
			if (/(http|https):\/\/([\w.]+\/?)\S*/.test(item)) {
				return item
			}
			return this.baseUrl + item
		},
		edit () {
			this.$emit('saveUrl', '')
			this.$nextTick(() => {
				setTimeout(() => {
					this.$refs.uploadComponent.$children[0].$el.click()
				}, 200)
			})
		},
		async del (index) {
			await this.$confirm('确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
			if (this.type == 'list') {
				const arr = this.imageUrl
				arr.splice(index, 1)
				this.$emit('saveUrl', arr)
			} else {
				this.$emit('saveUrl', '')
			}
		},
		async fnUploadRequest (params) {
			const _file = params.file
			// 通过 FormData 对象上传文件
			const formData = new FormData()
			formData.append('file', _file)
			if (this.state == 3) {
				const res = await this.$store.dispatch('upload/uploadImg', {
					data: formData,
					uploadKey: this.uploadKey,
					merchantId: this.merchantId
				})
				console.log(res)
				console.log(this.baseUrl)

				if (res && this.type == 'list') {
					const arr = this.imageUrl
					arr.push(res.fileNameUrl)
					this.$emit('saveUrl', arr)
				} else if (res) {
					console.log(res.fileNameUrl)
					this.$emit('saveUrl', res.fileNameUrl)
				}
			} else {
				// 发起请求
				const res = await this.$store.dispatch('upload/upload', {
					data: formData,
					uploadKey: this.uploadKey
				})
				console.log(res)
				console.log(this.baseUrl)

				if (res && this.type == 'list') {
					const arr = this.imageUrl
					arr.push(res.fileNameUrl)
					this.$emit('saveUrl', arr)
				} else if (res) {
					console.log(res.fileNameUrl)
					this.$emit('saveUrl', res.fileNameUrl)
				}
			}
		},
		beforeUpload (file) {
			// 新增菜品图片大小设置
			if (this.state == 2) {
				const _this = this
				// todo
				const types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png']

				const isImage = types.includes(file.type)
				console.log(file)
				const isLtSize = file.size / 1024 < this.maxSize

				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!')

					return false
				}
				if (!isLtSize) {
					this.$message.error(`上传图片大小不能超过 ${this.maxSizeUnit}!`)

					return false
				}

				const img = new Image()
				const _URL = window.URL || window.webkitURL
				img.src = _URL.createObjectURL(file)
				const pixel = new Promise(function (resolve, reject) {
					img.onload = function () {
						/* 有时我们不能完全满足宽高比是相同的，
                	等比例缩放后的图片会有细微的比例差距
                	这时就要用到等比例缩放的方式来计算判断是否满足上传的要求 */
						// 固定宽与上传图片的宽比
						// const widthRito = 750 / img.width
						// 固定高与上传图片的高比
						// const heightRito = 600 / img.height
						// 缩放比列的计算，如果宽比小于高比取宽比，否则取高比
						// const rito = widthRito < heightRito ? widthRito : heightRito
						// 得到缩放后图片的宽
						// const currentWidth = img.width * rito
						// 得到缩放后图片的高
						// const currentHeight = img.height * rito
						// 判断缩放后的宽高比是否会和固定的宽高比一样，
						// 因为缩放后等到的宽高会有细微小数的差距，
						// 所以用四舍五入可以得到和固定的宽高相同
						// let valid = Number(Number.parseFloat(currentWidth).toFixed())/Number(Number.parseFloat(currentHeight).toFixed()) == 750 / 430;

						/* 直接根据上传图片宽高比是否满足固定宽高比 */
						// 判断图片比列是否满足310px*405px
						const valid = img.width / img.height == 750 / 600
						// 满足条件调用promis的resolve，否则reject
						valid ? resolve() : reject(new Error())
					}
				}).then(
					() => {
						// 成功返回
						return file
					},
					() => {
						// 不成功返回promis的reject，在element中当返回promis的reject时也会停止上传
						_this.$message.error('图片宽高比例为750px*600px')
						return Promise.reject(new Error())
					}
				)
				console.log(isLtSize && isImage && pixel)

				return isLtSize && isImage && pixel
			} else if (this.state == 3) {
				const _this = this
				// todo
				const types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png']

				const isImage = types.includes(file.type)
				console.log(file)
				const isLtSize = file.size / 1024 < this.maxSize

				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!')

					return false
				}
				if (!isLtSize) {
					this.$message.error(`上传图片大小不能超过 ${this.maxSizeUnit}!`)

					return false
				}

				const img = new Image()
				const _URL = window.URL || window.webkitURL
				img.src = _URL.createObjectURL(file)
				const pixel = new Promise(function (resolve, reject) {
					img.onload = function () {
						const width = 2160
						const height = 3840
						const valid = img.width < width && img.height < height
						valid ? resolve() : reject(new Error())
					}
				}).then(
					() => {
						// 成功返回
						return file
					},
					() => {
						// 不成功返回promis的reject，在element中当返回promis的reject时也会停止上传
						_this.$message.error('图片最大宽高为2160px*3840px')
						return Promise.reject(new Error())
					}
				)
				console.log(isLtSize && isImage && pixel)

				return isLtSize && isImage && pixel
			} else if (this.state == 4) {
				const _this = this
				// todo
				const types = ['image/jpeg', 'image/png']

				const isImage = types.includes(file.type)
				console.log(file)
				const isLtSize = file.size / 1024 < 5120

				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、PNG 格式!')

					return false
				}
				if (!isLtSize) {
					this.$message.error('上传图片大小不能超过5M!')

					return false
				}

				const img = new Image()
				const _URL = window.URL || window.webkitURL
				img.src = _URL.createObjectURL(file)
				const pixel = new Promise(function (resolve, reject) {
					img.onload = function () {
						// const widthRito = 400 / img.width
						// const heightRito = 400 / img.height
						// const rito = widthRito < heightRito ? widthRito : heightRito
						// const currentWidth = img.width * rito
						// const currentHeight = img.height * rito
						const valid = img.width / img.height == 400 / 400
						valid ? resolve() : reject(new Error())
					}
				}).then(
					() => {
						return file
					},
					() => {
						_this.$message.error('图片宽高比例为1:1')
						return Promise.reject(new Error())
					}
				)
				console.log(isLtSize && isImage && pixel)

				return isLtSize && isImage && pixel
			} else if (this.state == 5) {
				const _this = this
				// todo
				const types = ['image/jpeg', 'image/png']

				const isImage = types.includes(file.type)
				console.log(file)
				const isLtSize = file.size / 1024 < 5120

				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、PNG 格式!')

					return false
				}
				if (!isLtSize) {
					this.$message.error('上传图片大小不能超过5M!')

					return false
				}

				const img = new Image()
				const _URL = window.URL || window.webkitURL
				img.src = _URL.createObjectURL(file)
				const pixel = new Promise(function (resolve, reject) {
					img.onload = function () {
						const valid = img.width / img.height == 400 / 300
						valid ? resolve() : reject(new Error())
					}
				}).then(
					() => {
						return file
					},
					() => {
						_this.$message.error('图片宽高比例为4:3')
						return Promise.reject(new Error())
					}
				)
				console.log(isLtSize && isImage && pixel)

				return isLtSize && isImage && pixel
			}
			// todo
			const types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png']

			const isImage = types.includes(file.type)
			console.log(file)
			const isLtSize = file.size / 1024 < this.maxSize

			if (!isImage) {
				this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!')

				return false
			}

			if (!isLtSize) {
				this.$message.error(`上传图片大小不能超过 ${this.maxSizeUnit}!`)

				return false
			}

			return true
		}
	}
}
</script>
